import { twMerge } from "tailwind-merge";

import { LinkBroken } from "@/assets/icons/LinkBroken";
import { Button } from "@/components/button";

import { Loading } from "./Loading";

interface DisconnectButtonProps {
  className?: string;
  isDisabled: boolean;
  loading: boolean;
  onPress: () => void;
}

export default function DisconnectButton({
  className,
  isDisabled,
  loading,
  onPress,
}: DisconnectButtonProps) {
  return (
    <Button
      className={twMerge(
        "text-text-error-primary h-10 w-35 border-[#fda29b] mt-5 sm:mt-0",
        className,
      )}
      isDisabled={isDisabled}
      onPress={onPress}
      variant="secondary"
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <LinkBroken className="mr-1" />
          <p className="max-[401px]:hidden">Disconnect</p>
        </>
      )}
    </Button>
  );
}
